export const DASHBOARD_ASSETS = [
  "EURUSD",
  "GBPUSD",
  "USDCAD",
  "USDJPY",
  "CADCHF",
  "EURJPY",
];

export const DASHBOARD_MARKETS: Record<string, string> = {
  EURUSD: "Forex",
  GBPUSD: "Forex",
  USDCAD: "Forex",
  USDJPY: "Forex",
  CADCHF: "Forex",
  EURJPY: "Forex",
};

export const DASHBOARD_EXPIRIES = [
  { label: "M1 - 1 min", value: "1 min", min: 1 },
  { label: "M3 - 3 min", value: "3 min", min: 3 },
  { label: "M5 - 5 min", value: "5 min", min: 5 },
  { label: "M10 - 10 min", value: "10 min", min: 10 },
  { label: "M15 - 15 min", value: "15 min", min: 15 },
];

export const DASHBOARD_RISK_NOTE =
  "Probabilidade indicativa, nao garante resultado.";

export const DASHBOARD_COLORS = {
  green: "#14b86a",
  greenDeep: "#0b7d45",
  mint: "#6fcf97",
  forest: "#0c2e22",
  chartreuse: "#dce89c",
  offwhite: "#f5f5f3",
};
